import { render, staticRenderFns } from "./NewsVideoTwo.vue?vue&type=template&id=f86e12ca&scoped=true"
import script from "./NewsVideoTwo.vue?vue&type=script&lang=js"
export * from "./NewsVideoTwo.vue?vue&type=script&lang=js"
import style0 from "./NewsVideoTwo.vue?vue&type=style&index=0&id=f86e12ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f86e12ca",
  null
  
)

export default component.exports